export const parseStatusesFromQueryParam = (value: string | null) => {
  if (!value) {
    return [];
  }

  return value
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};
